import { doc, getDoc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

function activityRef(matchId) {
  return doc(db, "activities", matchId);
}

export async function fetchActivitySnapshot(matchId) {
  const snap = await getDoc(activityRef(matchId));
  return snap.exists() ? snap.data() : null;
}

/**
 * @param {string} matchId
 * @param {Record<string, unknown>} payload
 */
export async function saveActivitySnapshot(matchId, payload) {
  await setDoc(
    activityRef(matchId),
    {
      matchId,
      ...payload,
      updatedAtMs: Date.now(),
    },
    { merge: true }
  );
}

/** @returns {import('firebase/firestore').Unsubscribe} */
export function subscribeActivitySnapshot(matchId, onData) {
  return onSnapshot(
    activityRef(matchId),
    (snap) => {
      const meta = {
        fromCache: snap.metadata.fromCache,
        hasPendingWrites: snap.metadata.hasPendingWrites,
      };
      if (snap.exists()) onData({ id: snap.id, ...snap.data() }, meta);
      else onData(null, meta);
    },
    { includeMetadataChanges: true }
  );
}
